import React from 'react'
import PoliciesAndNetworks from '../PoliciesAndNetworks/PoliciesAndNetworks'
import Sitemap from '../Sitemap/Sitemap'
import Supporters from '../Supporters/Supporters'

export default function Footer() {
    return (
        <>
            <Sitemap />
            <Supporters />
            <PoliciesAndNetworks />
        </>
    )
}
